import { onEscape } from './esc';
import { dockChat } from './chat';
// 화면 공유 보이기: 학교 칠판(게임 캔버스 안), 테이블의 큰 칸(영상 칸 줄 위), 크게 보기 겹침창. 모양은 index.html (#avShare, #share-view, #boardVideo).
// 공유 영상은 모임마다 한 사람의 것이다(서버 규칙). 어느 영상인지는 부르는 쪽(net/presence.ts)이 정해 refreshShare에 넘긴다.
const G = (window as any).G;
const $ = (id: string) => document.getElementById(id) as HTMLElement;
type Feed = { stream: MediaStream; name: string; school: boolean } | null;
let feed: Feed = null, open = false, lostAt = 0;
let board: HTMLVideoElement, tile: HTMLElement, tileVideo: HTMLVideoElement, view: HTMLElement, viewVideo: HTMLVideoElement;

const attach = (v: HTMLVideoElement, s: MediaStream | null) => { if (v.srcObject !== s) { v.srcObject = s; if (s) v.play().catch(() => {}); } };

export function initBoard() {
  board = $('boardVideo') as HTMLVideoElement; tile = $('avShare'); tileVideo = tile.querySelector('video')!; view = $('share-view'); viewVideo = $('sv-video') as HTMLVideoElement;
  tile.addEventListener('mousedown', (e) => e.preventDefault());
  tile.addEventListener('click', openShare);
  for (const b of ['sv-full', 'sv-close']) $(b).addEventListener('mousedown', (e) => e.preventDefault());   // 단추가 포커스를 가지면 Enter가 단추를 누른다(채팅 열기 키)
  $('sv-close').addEventListener('click', closeShare);
  $('sv-full').addEventListener('click', () => { const f = view.requestFullscreen || (view as any).webkitRequestFullscreen; if (document.fullscreenElement) document.exitFullscreen(); else if (f) Promise.resolve(f.call(view)).catch(() => {}); });
  onEscape({ isOpen: () => open, close: () => { if (!document.fullscreenElement) closeShare(); } });   // 전체 화면 중의 Esc는 브라우저가 전체 화면만 끝낸다
  // 칠판을 누르면 크게 본다: 캔버스 위치를 게임 좌표(384x216)로 바꿔 장면(town.js)에 묻는다
  const cv = $('game') as HTMLCanvasElement;
  cv.addEventListener('click', (e) => {
    const r = cv.getBoundingClientRect(), x = (e.clientX - r.left) / r.width * G.W, y = (e.clientY - r.top) / r.height * G.H;
    if (G.scene && G.scene.boardAt && G.scene.boardAt(x, y)) openShare();
  });
}

export function openShare() {
  if (!feed || open) return;
  open = true; view.hidden = false; G.input.locked = true; dockChat($('sv-chat'));
  $('sv-title').textContent = feed.name + '님의 화면';
  attach(viewVideo, feed.stream);
}
export function closeShare() {
  if (!open) return;
  open = false; view.hidden = true; G.input.locked = false; attach(viewVideo, null); dockChat(null);
  if (document.fullscreenElement) document.exitFullscreen().catch(() => {});
}

// 공유 영상이 바뀌었으면 칠판·큰 칸·겹침창의 영상을 바꾼다. 프레임마다 부른다(같은 것이면 아무것도 안 한다)
export function refreshShare(f: Feed) {
  feed = f;
  attach(board, f ? f.stream : null);
  attach(tileVideo, f && !f.school ? f.stream : null);
  tile.hidden = !f || f.school;   // 학교는 칠판에 보인다
  if (f) { tile.querySelector('.avName')!.textContent = f.name + '님의 화면'; if (open) { $('sv-title').textContent = f.name + '님의 화면'; attach(viewVideo, f.stream); } }
  // 크게 보는 중에 영상이 잠깐 끊겨 보여도(연결 상태 알림이 오가는 사이) 바로 닫지 않는다: 1.5초 이어서 없을 때만 닫는다
  if (f) lostAt = 0; else if (open) { if (!lostAt) lostAt = performance.now(); else if (performance.now() - lostAt > 1500) { lostAt = 0; closeShare(); } }
}
// 칠판에 그릴 영상: 첫 프레임이 도착하기 전에는 ready가 false다
export const boardFeed = () => (feed ? { video: board, name: feed.name, ready: board.readyState >= 2 && board.videoWidth > 0 } : null);
